

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://e851506caba54d6fa11e9a953b4a5d51@sentry-next.wixpress.com/21551", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RelatedPosts/Widget/index.tsx';
    import createController from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/RelatedPosts/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'RelatedPosts';
    var projectName = 'communities-blog-ooi';
    var sentryConfig = {
      DSN: 'https://e851506caba54d6fa11e9a953b4a5d51@sentry-next.wixpress.com/21551',
      id: 'e851506caba54d6fa11e9a953b4a5d51',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas-feds',
      errorMonitor: true,
    };
    

    var stylesParams = null;
    var customCssVars = function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["wix-social-blog","ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"like-button.aria-label.unlike":"Unlike post","post-actions.duplicate-post":"Duplicate Post","like-button.comment-is-liked":"Comment marked as liked","post-actions.unpin-post":"Unpin post","ratings-display.no-ratings":"No ratings yet","post-actions.enable-commenting":"Turn on commenting","no-posts.publish-posts-to-see-them":"Publish your posts to see them here.","related-posts.see-all-link.label":"See All","ratings-display.count":"{count, plural, =0 {No ratings} one {# Rating} other {# Ratings}}","post-actions.pin-post":"Pin to feed","counter.count":"{count, number}","ratings-display.rating-aria-label":"Rated {rating, plural, one {#} other {#}} out of 5 stars.","post-list-item.aria-label.pinned-post":"Pinned post","view-count.label":"{count, plural, one {# view} other {# views}}","time-to-read.short-label":"{minutes} min","post-actions.print":"Print Post","like-button.comment-is-unliked":"Comment not marked as liked","related-posts.title":"Related Posts","like-button.total-likes":"like.","like-button.is-unliked":"Post not marked as liked","post-actions.follow":"Follow post","post-actions.edit-post":"Edit post","like-button.is-liked":"Post marked as liked","aria-label.authors-picture":"Writer","more-button.more-actions":"More actions","post-actions.share-post":"Share post","few-seconds-ago":"a few seconds ago","post-actions.disable-commenting":"Turn off commenting","no-posts-feed.nothing-to-show":"Looks like you don’t have any posts to show","pro-gallery.parent-container-aria-label":"Related Posts. Select a post to read.","like-button.total-likes_plural":"likes.","post-actions.unfollow":"Unfollow post","post-actions.duplicate-post-copy-of":"Copy of","like-button.aria-label.like":"Like post","comment-count.label":"{count, plural, one {# comment} other {# comments}}","time-to-read.label":"{minutes} min read","post-actions.delete-post":"Delete post"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14bcded7-0066-7c35-14d7-466cb3f09103";
    var componentId = "46a9e991-c1cc-47c9-b19a-e99d3be1e2c9";
    var localeDistPath = 'components/RelatedPosts/locales/widget';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = true;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
